import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "./styles/animations.css";

const container = document.getElementById("root");

if (!container) {
  console.error("Elemento root não encontrado!");
  throw new Error("Elemento #root não encontrado no DOM");
}

const root = createRoot(container);

// Adicionar tratamento de erro global
window.addEventListener('error', (event) => {
  console.error('Erro global capturado:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Promise rejeitada não tratada:', event.reason);
});

try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Erro ao renderizar aplicação:', error);
  container.innerHTML = `
    <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f3f4f6; padding: 20px;">
      <div style="max-width: 500px; background: white; padding: 30px; border-radius: 8px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <h1 style="color: #ef4444; margin-bottom: 16px;">⚠️ Erro ao Carregar Aplicação</h1>
        <p style="color: #6b7280; margin-bottom: 20px;">Ocorreu um erro ao inicializar a aplicação. Por favor, recarregue a página.</p>
        <button onclick="window.location.reload()" style="width: 100%; padding: 12px; background: #3b82f6; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 16px;">
          Recarregar Página
        </button>
        <details style="margin-top: 20px;">
          <summary style="cursor: pointer; color: #6b7280; font-size: 14px;">Detalhes do erro</summary>
          <pre style="margin-top: 10px; padding: 10px; background: #f3f4f6; border-radius: 4px; overflow: auto; font-size: 12px;">${error.toString()}</pre>
        </details>
      </div>
    </div>
  `;
}
